import { render, staticRenderFns } from "./TestTypeDetail.vue?vue&type=template&id=374251cd&scoped=true&"
import script from "./TestTypeDetail.vue?vue&type=script&lang=js&"
export * from "./TestTypeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374251cd",
  null
  
)

export default component.exports